<script setup lang="ts">
defineProps<{
  label: string
  title: string
  centered?: boolean
}>()
</script>

<template>
  <div :class="['section-header', { 'text-center': centered }]">
    <p class="section-label">{{ label }}</p>
    <h2 class="section-title" v-html="title"></h2>
    <div class="accent-line"></div>
  </div>
</template>

<style scoped>
.section-header {
  margin-bottom: 0;
}

.text-center {
  text-align: center;
}

.text-center .accent-line {
  margin-left: auto;
  margin-right: auto;
}

.section-label {
  font-family: 'HND', sans-serif;
  font-size: 0.75rem;
  color: var(--pink-bright);
  letter-spacing: 0.16em;
  text-transform: uppercase;
  margin-bottom: 12px;
  font-weight: 600;
}

.section-title {
  font-family: 'HND', sans-serif;
  font-weight: 950;
  font-size: clamp(2rem, 4vw, 3.2rem);
  color: var(--white);
  text-transform: uppercase;
  margin-bottom: 8px;
}

.accent-line {
  width: 48px;
  height: 3px;
  background: linear-gradient(90deg, var(--pink), var(--purple));
  margin-top: 12px;
  border-radius: 4px;
}

@media (max-width: 768px) {
  .section-title {
    font-size: clamp(1.6rem, 6vw, 2.2rem);
    margin-bottom: 6px;
  }

  .section-label {
    font-size: 0.7rem;
    letter-spacing: 0.12em;
    margin-bottom: 10px;
  }

  .accent-line {
    width: 36px;
    margin-top: 10px;
  }
}
</style>
